import axios from 'axios';
import qs from 'qs';

// 创建一个自定义的axios
const request = axios.create();

// api url
// request.defaults.baseURL = process.env.REACT_APP_API_BASE_URL;
// request.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
// request.defaults.headers.put['Content-Type'] = 'application/x-www-form-urlencoded';

/**
 * 请求拦截器
 * 处理token
 */
request.interceptors.request.use(
  async config => {
    const token = sessionStorage.getItem('accessToken');
    config.headers['X-authorization'] = token;
    // config.headers['X-version'] = "";
    config.headers['X-app'] = process.env.REACT_APP_AUTH_APP;
    config.headers['Content-Type'] = "application/x-www-form-urlencoded";
    console.log(config);
    return config;
  },
  error => Promise.reject(error)
);

/**
 * 响应拦截器
 * 处理响应错误
 * 处理重新登录
 * 401, 403
 * 等等
 */
request.interceptors.response.use(response => response, error => Promise.reject(error));

/**
 * get request
 * @param {*g} url
 */
async function get(url) {
  return request.get(url);
}

/**
 * post request
 * @param {*} url
 * @param {*} data
 */
async function post(url, data) {
  return request.post(url, data);
}

/**
 * delete request
 * @param {*g} url
 */
async function del(url) {
  return request.delete(url);
}

/**
 * put request
 * @param {*} url
 * @param {*} data
 */
async function put(url, data) {
  return request.put(url, data);
}

/**
 * post form表单提交
 * @param {*} url
 * @param {*} data
 */
async function formPost(url, data) {
  const headers = { 'Content-Type': 'application/x-www-form-urlencoded' };
  return request.post(url, qs.stringify(data, { arrayFormat: 'repeat' }), {
    headers
  });
}

/**
 * get form表单提交
 * @param {*} url
 * @param {*} data
 */
async function formGet(url) {
  const headers = { 'Content-Type': 'application/x-www-form-urlencoded' };
  return request.get(url, { headers });
}

/**
 * 文件上传
 * @param {*} url
 * @param {*} formData
 */
async function upload(url, formData) {
  const headers = {
    'Content-Type': 'multipart/form-data',
    Accept: 'application/json',
  };
  return request.post(url, formData, { headers });
}

const ajax = {
  get: url => get(url),
  post: (url, data) => post(url, data),
  delete: url => del(url),
  put: (url, data) => put(url, data),
  formPost: (url, data) => formPost(url, data),
  formGet: url => formGet(url),
  upload: (url, formData) => upload(url, formData),
};

export default ajax;



// WEBPACK FOOTER //
// ./src/api/ajax.js